import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
    selector: 'app-loading-badge',
    templateUrl: './loading-badge.component.html',
    styleUrls: ['./loading-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe]
})
export class LoadingBadgeComponent implements OnChanges, OnDestroy {
  @Input() active: boolean = false;
  @Input() textKey: string = 'connect.calendar.loading_bookings';
  @Input() textFallbackKey: string = 'connect.calendar.loading_bookings';
  @Input() ariaLabelKey: string = 'connect.calendar.loading_bookings';
  @Input() autoHideAfterMs: number | null = 15000;

  @Output() autoHide = new EventEmitter<void>();

  visible: boolean = false;
  private hideTimer: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['active']) {
      if (this.active) {
        this.visible = true;
        this.startAutoHideTimer();
      } else {
        this.visible = false;
        this.clearTimer();
      }
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private startAutoHideTimer() {
    this.clearTimer();
    if (this.autoHideAfterMs && this.autoHideAfterMs > 0) {
      this.hideTimer = setTimeout(() => {
        this.visible = false;
        this.autoHide.emit();
      }, this.autoHideAfterMs);
    }
  }

  private clearTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
}

